import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import FloatingMenu from './components/FloatingMenu';
import Reseptit from './views/Reseptit';
import ReseptiView from './views/Resepti';
import FavoritesView from './views/Favorites';
import RandomRecipes from './views/RandomRecipes';

function App() {
    const [recipes, setRecipes] = useState([]);

    useEffect(() => {
        fetch('/reseptit.json')
            .then(response => response.json())
            .then(data => setRecipes(data))
            .catch(error => console.error('Error fetching recipes:', error));
    }, []);

    return (
        <Router>
            <div className="App">
                {/* Main Content */}
                <Routes>
                    <Route path="/" element={<Reseptit />} />
                    <Route path="/resepti/:id" element={<ReseptiView />} />
                    <Route path="/favorites" element={<FavoritesView />} />
                    <Route path="/random-recipes" element={<RandomRecipes />} />
                </Routes>

                {/* Floating Menu is only rendered if not on the single recipe view */}
                <ConditionalFloatingMenu />
            </div>
        </Router>
    );
}

// Component to conditionally render FloatingMenu based on location
function ConditionalFloatingMenu() {
    const location = useLocation();

    // Check if the current path is the single recipe view path
    const isSingleRecipeView = location.pathname.startsWith('/resepti/');

    return !isSingleRecipeView && <FloatingMenu />;
}

export default App;
